
export default {
  name: "debCamp",
  data() {
    return {
      cuerpo: '',
      titulo: '', 

    };
  },
  mounted: function () {
    if (window.debito_mensaje_estado==0) {
      this.getMessage();
    }
  
  },
  components: {
  },
  computed: {
  },

  methods: {

    toRegistrar(){

      setTimeout(() => {
        window.location="/#/config/debAuto";
      }, 500);
    },
    
    masTarde(){

      setTimeout(() => {
        window.location="/#/config/debAuto";
      }, 500);
    },
    getMessage() {
      this.$http
        .get(
          "/config/debito/automatico/message",
          {
            withCredentials: true
          }
        )
        .then(response => {

          if (response.data.data.length > 0) {

           $("#avviSgeneral").empty().append(response.data.data[0][0])
            $("#aaviStitle").empty().append(response.data.data[0][1])

            $('#exampleModalScrollable').modal({ show: true, backdrop: 'static' })
          }

          window.debito_mensaje_estado=1;
         
        });
    },
  }

};



// WEBPACK FOOTER //
// ./src/components/general/campaDebito/index.js